module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAAMFBMVEUAAAAAc8gAc8kAc8kAcskAc8gAc8gAcsoAc8gAc8gAc8cAc8gAcskAcskAcskAc8g/54x1AAAAD3RSTlMAmZJZM/XAOe3q2sxQJgReAjhHAAAANElEQVQI12MAAl4DEOmZACSY/iswMPD0/xdgYNn/H0iyrweRDMzxIJLhIVAWCEoTQCSLAQCGww3BmyvGpQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_bgPrevious2.png
// module id = 8cWr
// module chunks = 9